export default __webpack_public_path__ + "static/phone-1-7917a0df6d5ee4718e96ed6379c81101.jpeg";